/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPatternMatch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 5h3v14h-3v2h5V3h-5v2zM3 3H2v18h5v-2H4V5h3V3H3zm4.685 11.248V16h1.992v-1.752H7.685zm3.317 0V16h1.992v-1.752h-1.992zm3.316 0V16h1.992v-1.752h-1.992z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPatternMatch as PatternMatch };
